import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Badge, Button, ButtonGroup, Card, Col, Row, Spinner } from "react-bootstrap";

import { risky as getRiskyBoardTasks } from "../../../actions/boards";
import { isGuid } from "../../../utils/string";
import { format as formatDate } from "../../../utils/date";

const personName = (person) => person?.displayName || [person?.firstName, person?.lastName].filter(Boolean).join(" ") || "Person";

class BoardTaskWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scope: "mine",
            loading: false,
            items: []
        };
    }

    componentDidMount = async () => {
        await this.loadData();
    };

    loadData = async () => {
        this.setState({ loading: true });
        const result = await this.props.getRiskyBoardTasks({ mine: this.state.scope === "mine", limit: 8 });
        this.setState({
            loading: false,
            items: result?.success && Array.isArray(result.items) ? result.items : []
        });
    };

    setScope = async (scope) => {
        if (scope === this.state.scope) return;
        this.setState({ scope }, this.loadData);
    };

    openTask = (item) => {
        if (!isGuid(item?.personUuid)) return;
        const task = isGuid(item?.uuid) ? `&task=${item.uuid}` : "";
        window.location.href = `/dashboard/people/${item.personUuid}?tab=board${task}`;
    };

    renderRisk = (item) => {
        const risks = [];
        if (item.startOverdue) risks.push(<Badge key="start" bg="danger" className="me-1">start</Badge>);
        if (item.finishSoon) risks.push(<Badge key="finish" bg="warning" text="dark" className="me-1">finish</Badge>);
        return risks;
    };

    renderItem = (item) => (
        <button
            key={item.uuid}
            type="button"
            className="btn btn-link w-100 text-start p-0 text-body text-decoration-none"
            onClick={() => this.openTask(item)}
        >
            <div className="py-2 border-bottom">
                <Row className="g-2 align-items-center">
                    <Col xs="8" className="text-truncate">
                        <div className="fw-bold text-truncate">{item.title || "Board task"}</div>
                        <div className="small text-muted text-truncate">
                            {personName(item.Person)}
                            {item.AssignedTo ? ` · ${personName(item.AssignedTo)}` : ""}
                        </div>
                    </Col>
                    <Col xs="4" className="text-end">
                        <div>{this.renderRisk(item)}</div>
                        <div className="small text-muted text-truncate">
                            {item.finishBy ? formatDate(item.finishBy, true) : item.startBy ? formatDate(item.startBy, true) : ""}
                        </div>
                    </Col>
                </Row>
            </div>
        </button>
    );

    render() {
        return (
            <Card className="h-100">
                <Card.Header>
                    <Row className="align-items-center g-2">
                        <Col>
                            <span className="fw-bold">Board Tasks</span>
                        </Col>
                        <Col xs="auto">
                            <ButtonGroup
                                ariaLabel="Board task scope"
                                size="sm"
                            >
                                <Button
                                    type="button"
                                    variant={this.state.scope === "mine" ? "primary" : "outline-primary"}
                                    aria-pressed={this.state.scope === "mine"}
                                    onClick={() => this.setScope("mine")}
                                >
                                    Mine
                                </Button>
                                <Button
                                    type="button"
                                    variant={this.state.scope === "all" ? "primary" : "outline-primary"}
                                    aria-pressed={this.state.scope === "all"}
                                    onClick={() => this.setScope("all")}
                                >
                                    All
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    {this.state.loading ? (
                        <div className="text-center py-4">
                            <Spinner animation="border" />
                        </div>
                    ) : this.state.items.length ? (
                        <div>{this.state.items.map(this.renderItem)}</div>
                    ) : (
                        <div className="text-muted py-3">No board tasks are at risk.</div>
                    )}
                </Card.Body>
            </Card>
        );
    }
}

BoardTaskWidget.propTypes = {
    auth: PropTypes.object.isRequired,
    getRiskyBoardTasks: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, {
    getRiskyBoardTasks
})(BoardTaskWidget);
